import BaseFilters from './BaseFilters';

export default {
  ...BaseFilters.BooleanFilter,
  name: 'isActive',
  label: 'global.enabledElement',
  options: [
    {
      label: 'global.text.enabled',
      value: 'true',
    },
    {
      label: 'global.text.disabled',
      value: 'false',
    },
  ],
};
